import { PatientFolderActions } from "redux_constants/patientfolder.state.constant"


const initialState = {
    allPatientFolders: [],
    totalCount: 0,
    page: 1,
    totalPage: 1,
    searchParamsMap: {},
    allTags: [],
}

export const patientfolderReducer = (state = initialState, action) => {
    const updatedState = Object.assign({}, state)

    switch (action.type) {
        case PatientFolderActions.ALL_FOLDERS_UPDATE:
            Object.assign(updatedState, { allPatientFolders: action.allPatientFolders })
            return updatedState

        case PatientFolderActions.PAGE_UPDATE:
            Object.assign(updatedState, { page: action.page })
            return updatedState

        case PatientFolderActions.TOTAL_PAGES_UPDATE:
            Object.assign(updatedState, { totalPage: action.totalPage })
            return updatedState

        case PatientFolderActions.TOTAL_COUNT_UPDATE:
            Object.assign(updatedState, { totalCount: action.totalCount })
            return updatedState

        case PatientFolderActions.SEARCH_PARAMS_UPDATE:
            Object.assign(updatedState, { searchParamsMap: { ...state.searchParamsMap, ...action.searchParamsMap } })
            return updatedState

        case PatientFolderActions.SEARCH_PARAMS_CLEAR:
            updatedState.searchParamsMap = {}
            return updatedState

        case PatientFolderActions.ALL_TAGS_UPDATE:
            Object.assign(updatedState, { allTags: action.allTags })
            return updatedState

        default:
            return state
    }
}